import api from "./api";
import qs from "qs";

export type FeedbackJobCreateProps = {
    jobId: number;
    customerId: number;
    feedbackItemEvaluationId: number;
    grade: number;
    evaluator: "fotop" | "cliente" | "proprietario";
    feedbackName?: string;
    customerFeedbackComment?: string;
    ownerFeedbackComment?: string;
};

const FeedbackJob = {
    async list({ filters = {} }) {
        const query = qs.stringify({ filters });
        return api.get(`/v1/job/feedback-job?${query}`).then((res) => res.data);
    },
    async getFeedbackInfoByToke({ token, respondent = "" }) {
        const query = qs.stringify({ respondent });
        return api.get(`/v1/job/feedback-info/${token}?${query}`).then((res) => res.data);
    },
    async create(data: FeedbackJobCreateProps) {
        return api.post(`/v1/job/feedback-job`, data);
    },
    async ownerCreate(data: FeedbackJobCreateProps, token = "") {
        const query = qs.stringify({ token });
        return api.post(`/v1/job/feedback-job/owner?${query}`, data);
    },
    async update(id: number, data: Partial<FeedbackJobCreateProps>) {
        return api.patch(`/v1/job/feedback-job/${id}`, data);
    },
};

export default FeedbackJob;
